import React from "react";

import { IonButtons, IonButton, IonIcon } from "@ionic/react";
import { add } from "ionicons/icons";

import { Link } from "react-router-dom";

const IonToolbar: React.FC = () => {
  return (
    <IonButtons slot="end">
      <Link to="/page/passage-new">
        <IonButton slot="end" style={{ color: "#fff" }}>
          <IonIcon icon={add} slot="icon-only" />
        </IonButton>
      </Link>
    </IonButtons>
  );
};

export default IonToolbar;
